import type { ArRowData, ArRowId } from '#types/System.Artifacts.types';
import type { DocEntry } from '@/store';
import { getSplitQueryKeyAndLabel } from '@/services/getSplitQueryKeyAndLabel';
import type { ArTableSplit } from './ArTableSplit';

type FilterArRowIdsBySplitParams = {
  rowIds: readonly ArRowId[];
  rowsDocs: ReadonlyMap<string, DocEntry<ArRowData>> | null;
  split: ArTableSplit | null;
};

function filterArRowIdsBySplit({
  rowIds,
  rowsDocs,
  split,
}: FilterArRowIdsBySplitParams): ArRowId[] {
  if (!split || !rowsDocs) return [...rowIds];

  const { typeId, filterValue } = split;
  const next: ArRowId[] = [];

  for (const rowId of rowIds) {
    const rowData = rowsDocs.get(rowId)?.data;
    const cellValue = rowData?.cells?.[typeId]?.value;
    const { key } = getSplitQueryKeyAndLabel(cellValue);
    if (key === filterValue) next.push(rowId);
  }

  return next;
}

export { filterArRowIdsBySplit };

